export enum OrderStatus {
    Unknown = 0,
    New = 1,
    NoValidQuote = 2,
    AnnouncedToCarrier = 3,
    BiddingPlace = 4,
    Confirmed = 5,
    Arrived = 6,
    Loading = 7,
    Departed = 8,
    Delivered = 9,
    Void = 10,
    CarrierAccepted = 11,
    CarrierDenied = 12,
    TimeExpired = 13,
    Loaded = 14,
    Cleaning = 15,
    ReadyForLoading = 16,
    CleaningCallInSend = 17,
    LoadingCallInSend = 21,
    NewBid = 18,
    BidRead = 19,
    DroppedEmpty = 22,
    DroppedFull = 23,
}
